<div class="header">
    <div class="logo logo-dark">
      <a (click)="redirectLogo()">
        <img src="assets/images/logo/logo.png" alt="Logo">
        <img class="logo-fold" src="assets/images/logo/logo-fold.png" alt="Logo">
      </a>
    </div>
    <div class="logo logo-white">
      <a (click)="redirectLogo()">
        <img src="assets/images/logo/logo-white.png" alt="Logo">
        <img class="logo-fold" src="assets/images/logo/logo-fold-white.png" alt="Logo">
      </a>
    </div>
    <div class="nav-wrap">
      <ul class="nav-left">
        <li class="desktop-toggle">
          <a (click)="toggleFold()">
            <i nz-icon [nzType]="isFolded ? 'menu' : 'menu'" theme="outline"></i>
          </a>
        </li>
        <li class="mobile-toggle">
          <a (click)="toggleExpand()">
            <i nz-icon [nzType]="isExpand ? 'menu' : 'menu'" theme="outline"></i>
          </a>
        </li>
      </ul>
      <ul class="nav-right">
        <li style="margin-right: 10px;">
          <span class="p-h-10 pointer" nz-dropdown [nzDropdownMenu]="profile" [nzTrigger]="'click'" [nzPlacement]="'bottomRight'">
            <nz-avatar [nzIcon]="'user'" nzSrc="assets/images/avatars/thumb-2.jpg"></nz-avatar>
          </span>
          <nz-dropdown-menu #profile="nzDropdownMenu">
            <ul nz-menu class="p-b-15 p-t-20">
              <li class="p-h-20 p-b-15 m-b-10 border-bottom">
                <div class="d-flex m-r-50">
                  <nz-avatar nzSize="large" nzSrc="assets/images/avatars/thumb-2.jpg"></nz-avatar>
                  <div class="m-l-10">
                    <p class="m-b-0 text-dark font-weight-semibold">{{ name }} {{ lastName }}</p>
                    <p class="m-b-0 opacity-07">{{ email }}</p>
                  </div>
                </div>
              </li>
              <li nz-menu-item *ngIf="!onlyExternalReports">
                <a class="p-v-5 d-flex align-items-center justify-content-between">
                  <div>
                    <i class="opacity-04 font-size-16" nz-icon nzType="user" theme="outline"></i>
                    <span class="m-l-10">Edit Profile</span>
                  </div>
                </a>
              </li>
              <li nz-menu-item *ngIf="!onlyExternalReports">
                <a class="p-v-5 d-flex align-items-center justify-content-between">
                  <div>
                    <i class="opacity-04 font-size-16" nz-icon nzType="lock" theme="outline"></i>
                    <span class="m-l-10">Account Setting</span>
                  </div>
                </a>
              </li>
              <li nz-menu-item *ngIf="!onlyExternalReports">
                <a class="p-v-5 d-flex align-items-center justify-content-between">
                  <div>
                    <i class="opacity-04 font-size-16" nz-icon nzType="project" theme="outline"></i>
                    <span class="m-l-10">Projects</span>
                  </div>
                </a>
              </li>
              <li nz-menu-item (click)="authService.logout()">
                <a class="p-v-5 d-flex align-items-center justify-content-between">
                  <div>
                    <i class="opacity-04 font-size-16" nz-icon nzType="logout" theme="outline"></i>
                    <span class="m-l-10">Logout</span>
                  </div>
                </a>
              </li>
            </ul>
          </nz-dropdown-menu>
        </li>
      </ul>
    </div>
  </div>
  